<div class="modal-header">
  <h5 class="modal-title d-flex align-items-center gap-2">
    <i class="fal fa-share-alt"></i> <ng-container i18n>Custom Channel</ng-container>
    <app-page-help articleId="-" videoId="-"></app-page-help>
  </h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <app-custom-channel-form [channel]="data.channel" #form></app-custom-channel-form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <ng-container *ngIf="isEdit; else create">
    <button (click)="onDelete()" type="button" class="btn btn-secondary-danger" [disabled]="form?.isLoading">
      <i class="cs-icon cs-icon-trash"></i> <ng-container i18n>Delete</ng-container>
    </button>
    <button (click)="onSave(form)" type="button" class="btn btn-secondary-info" [disabled]="form?.isLoading">
      <span class="cs-icon cs-icon-save" *ngIf="!form?.isLoading"></span>
      <span class="far fa-spin fa-spinner" *ngIf="form?.isLoading"></span>
      <ng-container i18n>Save</ng-container>
    </button>
  </ng-container>
  <ng-template #create>
    <button (click)="onCreate(form)" type="button" class="btn btn-secondary-info" [disabled]="form?.isLoading">
      <i class="far fa-plus" *ngIf="!form?.isLoading"></i>
      <span class="far fa-spin fa-spinner" *ngIf="form?.isLoading"></span>
      <ng-container i18n>Create</ng-container>
    </button>
  </ng-template>
</div>
